module.exports = __webpack_public_path__ + "media/images/pic/certificates/ifs-food-e1a331edcccbe93f992a47fa6fb04ea7.png";